import { render, staticRenderFns } from "./VendorDocumentsTable.vue?vue&type=template&id=9e9dbfa0"
import script from "./VendorDocumentsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorDocumentsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports